import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';

/*
 * Multimap interface and implementation.
 * This could potentially be moved into it's own file,
 * but it's only being leveraged by useRefMultiMap for the time being.
 */
// -------------- MultiMap ----------------- //
var MultimapEntry = /*#__PURE__*/_createClass(function MultimapEntry(key, value) {
  _classCallCheck(this, MultimapEntry);
  this.key = key;
  this.value = value;
});
// tslint:disable-next-line:max-classes-per-file
var ArrayListMultimap = /*#__PURE__*/function () {
  function ArrayListMultimap() {
    _classCallCheck(this, ArrayListMultimap);
    _defineProperty(this, "entries", []);
  }
  return _createClass(ArrayListMultimap, [{
    key: "getKeyAt",
    value: function getKeyAt(index) {
      return this.entries[index].key;
    }
  }, {
    key: "put",
    value: function put(key, value) {
      this.entries.push(new MultimapEntry(key, value));
      return this.entries;
    }
  }, {
    key: "size",
    value: function size() {
      return this.entries.length;
    }
  }]);
}();
// ----------------------------------------- //
/**
 * useRefMultiMap
 *
 * A "stateless" hook to handle sibling navigation (and eventually parent/child navigation)
 * with multimap-like React interfaces (i.e. folder trees, dropdown menus, etc.).
 */
function useRefMultiMap() {
  var currMultiMap;
  var currIndex;
  var setCurrMultiMap = function setCurrMultiMap(multiMap) {
    currMultiMap = multiMap;
  };
  var setCurrIndex = function setCurrIndex(index) {
    currIndex = index;
  };
  var getCurrIndex = function getCurrIndex() {
    return currIndex;
  };
  var navigateToNextSibling = function navigateToNextSibling() {
    if (currIndex < currMultiMap.size() - 1) {
      var newIndex = currIndex + 1;
      var nextSibling = currMultiMap.getKeyAt(newIndex).current;
      currIndex = newIndex;
      nextSibling.focus();
    } else {
      var _nextSibling = currMultiMap.getKeyAt(0).current;
      currIndex = 0;
      _nextSibling.focus();
    }
  };
  var navigateToPreviousSibling = function navigateToPreviousSibling() {
    if (currIndex > 0) {
      var newIndex = currIndex - 1;
      var previousSibling = currMultiMap.getKeyAt(newIndex).current;
      currIndex = newIndex;
      previousSibling.focus();
    } else {
      var nextSibling = currMultiMap.getKeyAt(currMultiMap.size() - 1).current;
      currIndex = currMultiMap.size() - 1;
      nextSibling.focus();
    }
  };
  return {
    navigateToNextSibling: navigateToNextSibling,
    navigateToPreviousSibling: navigateToPreviousSibling,
    setCurrIndex: setCurrIndex,
    setCurrMultiMap: setCurrMultiMap,
    getCurrIndex: getCurrIndex
  };
}

export default useRefMultiMap;
export { ArrayListMultimap, MultimapEntry };
